import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './OrchestraEmploymentsList.html?raw';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import "../../../moreCore/UI/_StatefulBase/_StatefulBase";
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import { OMtypes, OMclassnames, OMselectEntityDialogModes } from "../../_loadingHelpers/OM";
import EntityStore from '../../../moreCore/Tools/EntityStore';
import { AddressWizardTypes } from "../../AddressWizard/AddressWizardTypes";
import HintBox from '../../../moreCore/UI/HintBox/HintBox';
import "../../../moreCore/UI/HintBox/HintBox";
import { ToasterHelpers } from "../../../more/Helpers";

class OMemploymentList extends compose(_WidgetBaseSP) {
    templateString: any = template;
    private musicianInput: MdsLax<InstanceType<typeof HintBox>>

    private sectionAddEntry: HTMLElement;
    private tableContainer: HTMLElement;
    private table: MdsLax<InstanceType<typeof StaticTable>>;
    private store: MdsLax<InstanceType<typeof EntityStore<OMtypes.orchestraEmployment>>>;

    private evBookingId: string;

    private entitylist: Array<any>;

    private _tableLayout: StaticTable.RowConfig = {
        colNamesInternal: ["musicianName", "dutyType", "functionName", "subfunctionName"],
        "attributes": ["ref_associate.gDisp_Name_Firstname", "ref_vt_duty_type.description", "ref_functional_group.description", "ref_functional_sub_group.description"],
        "colspans": [1, 1, 1],
        "headings": [(this as any).translate("General_Label_Musician"), (this as any).translate("General_Label_DutyType"), (this as any).translate("General_Label_FunctionalGroup"), (this as any).translate("General_Label_FunctionalSubGroup")],
        widths: [null, null, null/*, "15ch"*/],
        alignmentsHeading: [null, null, null/*, "right"*/],
        alignmentsRow: [null, null, null/*, "right"*/],
        bgColors: [null, "ref_vt_duty_type.coloration", "ref_functional_group.coloration", "ref_functional_sub_group.coloration"]
    }

    private table_formatterFunction(cell: StaticTable.StaticTableCell<OMtypes.orchestraEmployment>) {
        let node = cell.contentnode;
        let entity = cell.entity;
        let colName = cell.name;
        let value = cell.value;
        let rowIndex = cell.tableRow.rowGroup.rowIndex;

        //cell.formattingHandled = true;
        let icon = null;
        switch (colName) {

            //case "musicianName":
            //    if (this._selectedEntities.indexOf(entity) != -1) {
            //        this.UiModder.domClass.add(cell.tableCellNode, "accentBG");
            //    }                
            //    break;
            //case "dutyType":
            //    if (entity.ref_vt_duty_type.coloration) {
            //        this.UiModder.domClass.add()
            //    }
            //    break;
            //case "functionName":
                    // ???
            //    return true;
            //    break;
            default:
                return false;
        }
    }
    private _emitHandle: any = null;
    private _onChange_StoreData() {
        let diffData = this.store.getDiffData();
        let completeList = this.store.getCurrentCompleteList();

        this._onClick_CancelSelection();

        if (!this.table) {
            this.setupTable();
        }

        //console.debug(this.id + ": _onChange_StoreData in EntityStore", diffData);

        if (this._emitHandle) {
            clearTimeout(this._emitHandle);
        }

        this._emitHandle = setTimeout(lang.hitch(this, this.emit, "change", diffData), 100);
    }
    private _onChangeMusicianInput(): void {
        let value = this.musicianInput.getValue() as AddressWizardTypes.AssociateEntity;

        if (value != null) {
            let fakeEntity: Partial<OMtypes.orchestraEmployment> = {
                ID: (Math.random() * 100000).toString(),
                ref_associate: value
            }
            
            this.store.addEntry(fakeEntity as any);

            this.musicianInput.setValue(null, true);
        }
    }

    getData() {
        return this.store.getCurrentCompleteList();
    }
    getDiffData() {
        let diffData = this.store.getDiffData();
        return diffData;
    }

    private setupTable(): void {

        this.tableContainer.innerHTML = null;
       

        this.table = new StaticTable();

        //if (this.hasUserRole("OrchestraEmployment_Edit")) this.table.setupRowSorting("order");//, lang.hitch(this, this._onRowSorting));
        this.table.setFormatter(lang.hitch(this, this.table_formatterFunction));

        if (this.hasUserRole("OrchestraEmployment_Delete")) this.table.addDefaultRowActionButton("delete");//, lang.hitch(this, this._onRowDeleting));
        //this.table.setHeadingLabelFormatter(this.table_formatterFunction__headingLabel);
        //this.table.addCustomRowActionButton("SMS", lang.hitch(this, this._onClick_SendSMS), "fas fa-sms", 1, this.translate("General_Label_SendSMS"));
        this.table.addDefaultRowActionButton("select");
        this.table.on("select", lang.hitch(this, this._onSelect));
        //this.table.addCustomRowActionButton("select",
        //    lang.hitch(this, this._onClick_Select),
        //    "fas fa-plus-circle",
        //    1,
        //    this.translate("General_Label_Select"),
        //    lang.hitch(this, this._checkActionAvailability)
        //);

        this.table.addLineConfig(this._tableLayout);

        this.table.setCyAttribute("OrchestraEmploymentsList");

        this.UiModder.domConstruct.place(this.table.domNode, this.tableContainer);

        //this.table.setData(this.entitylist);
        this.table.setupFromStore(this.store);
    }  

    private _checkActionAvailability(entity: OMtypes.orchestraEmployment) {
        for (let selectedEntity of this._selectedEntities) {
            if (selectedEntity.ID == entity.ID) return false;
        }

        return true;
    }

    private _selectedEntities: Array<OMtypes.orchestraEmployment> = null;
    private _onSelect() {
        this._selectedEntities = this.table.getSelectedEntities();
        this._handleSelectionToast();
        this.table.enableActionButton("select")

        //this.setupTable();
    }

    private _handleSelectionToast() {
        if (!this._selectedEntities?.length) {
            this.removeToast("selectionActionsOMemployments");
            return;
        }

        let SMSbutton: toastButton = {
            label: this.translate("General_Label_SendSMS"),
            icon: "fas fa-sms",
            callback: lang.hitch(this, this._onClick_SendSMS, null)
        }

        let cancelButton: toastButton = {
            label: null,//this.translate("General_Cancel"),
            icon: "far fa-times-circle",
            callback: lang.hitch(this, this._onClick_CancelSelection)

        }
        
        this.showToast({
            ID: "selectionActionsOMemployments",
            title: this._selectedEntities.length + " " + this.translate("General_selected"),
            options: {
                buttons: [
                    SMSbutton,
                    cancelButton
                ],
                closeButton: false
            },
            showClose: false,
            timeout: "permanent",
        })
    }

    private _onClick_CancelSelection() {
        this._selectedEntities = [];
        this._handleSelectionToast();

        if (!this._destroyed) {
            setTimeout(lang.hitch(this, this.setupTable), 20);
        }
    }

    private _onClick_SendSMS(rowGroup: StaticTable.StaticTableRowGroup<OMtypes.orchestraEmployment>) {
        let entities = this._selectedEntities;
        if (rowGroup) {
            entities = [rowGroup.entity];
        }
        let dlg = new GenericDialog();

        let subtitle = "";
        for (let entity of entities) {
            subtitle += (!!subtitle ? "<br>" : "" ) + entity.ref_associate.gDisp_Name_Firstname + " - " + entity.ref_functional_sub_group.description;
        }


        let message = this.UiModder.domConstruct.create("p", {
            innerHTML: this.translate("OrchestraEmployment_SMS_ConfirmationDlgMessage")
        });

      
        let input = this.UiModder.domConstruct.create("textarea", {
            innerHTML: this.stringReplaceAll(this.translate("OrchestraEmployment_SMScontent"), "<br/>", "\r\n"),
            className: "w3-input resizeV",
            rows: 8
        }, message, "last");

        dlg.show(
            message,
            this.translate("General_Label_SendSMS"),
            subtitle,
            null,
            "okcancel",
            lang.hitch(this, this._onSMSdlg, entities, input));
    }

    private _onSMSdlg(entities: Array<OMtypes.orchestraEmployment>, textarea: HTMLTextAreaElement, result: number) {
        if (result >= 1) {
            this.sendSMS(entities, textarea.value);
        }
        else {
            this._onClick_CancelSelection();
        }
    }

    sendSMS(entities: Array<OMtypes.orchestraEmployment>, template: string) {

        this.StandbyStart();

        this.RequestManager.callfunction("Webtool_API_EvBooking__SendOrchestraEmploymentSMS",
            {
                "contentTemplate": template,
                "selectedEmployments": entities
            },
            lang.hitch(this, this._onSendSMSresult),
            lang.hitch(this, this._onSendSMSerror) 
        );
    }

    private _onSendSMSresult(response: { sentEmployments: Array<{ ID: string, result: string }> }) {
        this.StandbyStop();

        let resultContainer = this.UiModder.domConstruct.create("div");
        let errorCounter = 0;

        for (let sent of response.sentEmployments) {
            for (let entity of this._selectedEntities) {
                if (entity.ID == sent.ID) {
                    let resultParagraph = this.UiModder.domConstruct.create("p", {
                        innerHTML: this.createFontawesomeIcon(sent.result == "success" ? "fas fa-check w3-text-green" : "fas fa-times w3-text-red", "&nbsp;").outerHTML +
                            entity.ref_associate.gDisp_Name_Firstname
                    }, resultContainer);

                    if (sent.result != "success") {
                        errorCounter++;
                        this.UiModder.domConstruct.create("span", {
                            innerHTML: sent.result,
                            className: "w3-text-red w3-block"
                        }, resultParagraph);
                    }
                    break;
                }
            }
        }

        this._onClick_CancelSelection();

        if (errorCounter == 0) {
            this.showToast({
                ID: this.id,
                title: this.translate("OrchestraEmployment_SMS_ToastTitle_Success"),
                message: resultContainer.outerHTML,
                iconClass: ToasterHelpers.ToasterIcons.confirmCheck,
            });
        } else {
            this.showToast({
                ID: this.id,
                title: this.translate("OrchestraEmployment_SMS_ToastTitle_Warning"),
                message: resultContainer.outerHTML,
                iconClass: ToasterHelpers.ToasterIcons.warning,
            });
        }

    }

    private _onSendSMSerror(error: more.requestErrorMessage) {
        this.StandbyStop();
        this.showToast({
            ID: this.id,
            title: this.translate("OrchestraEmployment_SMS_ToastTitle_Failed"),
            message: error.Message,
            iconClass: ToasterHelpers.ToasterIcons.error,
        });
    }

    setup(data: Array<OMtypes.orchestraEmployment>, evBookingID: string, evBookingTitle?: string) {
        this.store.setup(data, "ID");
        this._selectedEntities = [];
        this._handleSelectionToast();
        this.evBookingId = evBookingID;
        this.entitylist = data;
        this.setupTable();

        this.musicianInput.addRequestProperty("evBookingID", evBookingID);
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.store = new EntityStore();
        this.store.on("change", lang.hitch(this, this._onChange_StoreData));

        //this.hideNode(this.sectionAddEntry, !this.hasUserRole("OrchestraEmployment_Create"));

        this.musicianInput.enableSelectEntityDialog(true, null);// lang.hitch(this, this._onClick_OpenEvCastSED));
        this.musicianInput.setJsonRequestFormat("jsonData");
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }

    destroy(): void {
        super.destroy.apply(this, arguments as any);

        this._onClick_CancelSelection();       
    }
}

export default mdsWidget(OMemploymentList);